import { FunnelIcon } from '@heroicons/react/24/outline';
import CityFilter from './CityFilter';
import FeedHeaderPills from './FeedHeaderPills';

/**
 * City, home-filter pills, and filter icon (web feed).
 */
const FeedFilterToolbar = ({
  homeFilterOptions,
  typeFilterOptions,
  locationTags,
  onToggleFilters,
  totalSelectedFilterCount,
  showTopRow = true,
  showBottomRow = true,
}) => {
  return (
    <div className="flex w-full flex-col gap-y-3 py-3 md:flex-row md:flex-wrap md:items-center md:justify-between md:gap-x-6 md:gap-y-3.5">
      {showTopRow && (
        <div className="flex min-w-0 flex-1 flex-wrap items-center gap-4 md:gap-5">
          <div className="shrink-0">
            <CityFilter />
          </div>
        </div>
      )}
      {showBottomRow && (
        <div className="flex min-w-0 flex-1 items-center justify-between gap-4 md:justify-end md:gap-5">
          <div className="min-w-0 max-w-full flex-1 overflow-x-auto no-scrollbar sm:max-w-2xl sm:flex-initial">
            <FeedHeaderPills
              homeFilters={homeFilterOptions}
              locationOptions={locationTags}
              typeOptions={typeFilterOptions}
            />
          </div>
          <div className="relative shrink-0">
            <button
              type="button"
              className="relative cursor-pointer rounded-lg p-2.5 hover:bg-black/5 md:p-3"
              onClick={onToggleFilters}
              aria-expanded={undefined}
              aria-label={
                totalSelectedFilterCount > 0
                  ? `Filters (${totalSelectedFilterCount} selected)`
                  : 'Open filters'
              }
            >
              <FunnelIcon className="relative z-0 h-8 w-8 text-black" />
              {totalSelectedFilterCount > 0 && (
                <span
                  className={`absolute -right-0.5 -top-0.5 z-10 flex shrink-0 items-center justify-center rounded-full bg-black font-semibold tabular-nums leading-none text-white ring-2 ring-[#f1f5f9] ${
                    totalSelectedFilterCount > 9 ? 'h-6 w-6 text-[10px]' : 'h-5 w-5 text-[11px]'
                  }`}
                >
                  {totalSelectedFilterCount}
                </span>
              )}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default FeedFilterToolbar;
